module.exports = __webpack_public_path__ + "static/5-a025a37574b027bc2d1fce0580b9f809.jpg";